/** Map API horaires-exceptions → { [ymd]: plages[] } pour la grille Présences. */
export function mapInstructeurHoraireExceptionsResponse(response) {
  const byDate = {};
  for (const ex of response?.exceptions || []) {
    if (!ex?.date) continue;
    byDate[ex.date] = (ex.plages || []).map((p) => ({
      heureDebut: p.heureDebut,
      heureFin: p.heureFin,
    }));
  }
  return byDate;
}
